import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { setToast } from '@/entities/toast'
import { useAppDispatch, useAppSelector } from '@/shared/store'

import { StyledContainer } from './StyledOperationsPage'

export type OperationsPageProps = {
  //
}

export const OperationsPage: React.FC<OperationsPageProps> = () => {
  const activeGroupId = useAppSelector(state => state.userInterface.activeGroupId)
  const dispatch = useAppDispatch()

  useEffect(() => {
    // Callback from Stripe Subscription Plan upgrade during onboarding
    const urlParams = new URLSearchParams(window.location.search)
    const upgradeSuccess = urlParams.get('upgrade_success')
    const upgradeCancelled = urlParams.get('upgrade_cancelled')

    if (upgradeSuccess) {
      dispatch(setToast({
        open: true,
        severity: 'success',
        title: 'Welcome to Premium!',
        content: 'Your subscription has been activated. Enjoy your enhanced features!',
      }))

      window.history.replaceState({}, '', window.location.pathname)
    } else if (upgradeCancelled) {
      dispatch(setToast({
        open: true,
        severity: 'info',
        title: 'No worries!',
        content: 'You can upgrade anytime from your profile menu.',
      }))
      window.history.replaceState({}, '', window.location.pathname)
    }
  }, [dispatch])

  return (
    <StyledContainer>
      {activeGroupId !== -1 && <Outlet />}
    </StyledContainer>
  )
}
